import { graphql } from 'gatsby';
import React from 'react';
import { css } from '@emotion/react';
import { colors } from '../../primitives/colors';
import Link from '../../primitives/link';
import paddingDefault from '../../utils/padding-default';
import Container from '../../primitives/grid/container';
import PageTitle from '../../primitives/page-title';
import apCaseOnlyTitleTags from '../../utils/ap-case-only-title-tags';
import { breakpoints } from '../../primitives/tokens';

const styles = {
    link: css({
        textDecoration: 'underline',
        color: colors.primaryOrange,
    }),
    pageTitle: {
        marginBottom: '32px',
        maxWidth: '672px',
        [breakpoints.mb]: {
            marginBottom: '12px',
        },
    },
    list: css({
        paddingTop: '56px',
        paddingBottom: '56px',
        fontSize: '20px',
        lineHeight: '28px',
        fontWeight: 600,
    }),
    listHeading: {
        paddingBottom: '16px',
        marginBottom: '24px',
        borderBottomWidth: '1px',
        borderColor: colors.primaryOrange,
    },
    links: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        '>:not([hidden])~:not([hidden])': {
            marginTop: '28px',
        },
    }),
};

const FranchiseDisclosure: React.FC<Queries.FranchiseDisclosureDataFragment> = (data) => {
    const { pageHeading, lists } = data;

    return (
        <div css={paddingDefault()}>
            <Container>
                <PageTitle css={styles.pageTitle}>
                    {apCaseOnlyTitleTags(pageHeading)}
                </PageTitle>
                {lists && lists.map((list) => {
                    if (!list) return null;
                    const { listHeading, links } = list;
                    return (
                        <div css={styles.list} key={listHeading}>
                            <h2 css={styles.listHeading}>
                                {apCaseOnlyTitleTags(listHeading)}
                            </h2>
                            {links && (
                                <ul css={styles.links}>
                                    {links.map((link) => {
                                        if (!link) return null;
                                        const { title, href } = link;
                                        if (!title || !href) return null;
                                        return (
                                            <Link css={styles.link} className="hover-default" to={href} key={title}>
                                                {title}
                                            </Link>
                                        );
                                    })}
                                </ul>
                            )}
                        </div>
                    );
                })}
            </Container>
        </div>
    );
};

export const query = graphql`
  fragment FranchiseDisclosureData on CsFranchiseDisclosure {
    ... on CsFranchiseDisclosure {
      pageHeading
      lists {
        listHeading
        links {
          href
          title
        }
      }
    }
  }
`;

export default FranchiseDisclosure;
